export default __webpack_public_path__ + "static/media/teamEric.dcf34b55.png";